<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError === null">

  <div class="floating-alert-container">
    <div class="alert alert-dismissible"
         [class.alert-success]="callbackResult.status === CallbackResultStatus.success"
         [class.alert-danger]="callbackResult.status === CallbackResultStatus.error"
         role="alert" *ngIf="callbackResult !== null">
      {{ callbackResult.text }}
      <button type="button" class="close" (click)="callbackResult = null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

  <h2 class="mb-3">
    Configure Custom Customer Fields
    <span *ngIf="loadingFields" class="text-secondary">- Loading...</span>
  </h2>

  <div class="rounded-table-wrapper">
    <table class="table">

      <thead>
        <tr>
          <th>Name / Options</th>
          <th>Type</th>
          <th></th>
        </tr>
      </thead>

      <tbody>

        <ng-container *ngIf="fields.length > 0">
          <tr *ngFor="let field of fields">
            <td>
              {{ field.name }}
              <br *ngIf="field.name && field.options && field.options.length > 0">
              <ng-container *ngIf="field.options && field.options.length > 0">
                <ul class="pl-3 mb-0">
                  <ng-container *ngIf="field.options.length > 3">
                    <li>{{ field.options[0] }}</li>
                    <li>{{ field.options[1] }}</li>
                    <li>
                      <span class="text-muted">
                        &#8230; {{ field.options.length - 2 }} more options
                      </span>
                    </li>
                  </ng-container>
                  <ng-container *ngIf="field.options.length <= 3">
                    <li *ngFor="let option of field.options">{{ option }}</li>
                  </ng-container>
                </ul>
              </ng-container>
            </td>
            <td>{{ getCustomCustomerFieldTypeDisplay(field.field_type) }}</td>
            <td class="table-button-cell">
              <button class="btn btn-outline-primary btn-sm float-right"
                      [class.disabled]="loadingEdit"
                      [disabled]="loadingEdit"
                      (click)="openEditFieldModal(field)">
                Edit
              </button>
              <button class="btn btn-outline-danger btn-sm float-right mr-2"
                      [class.disabled]="loadingEdit"
                      [disabled]="loadingEdit"
                      (click)="openRemoveFieldModal(field)">
                Remove
              </button>
            </td>
          </tr>
        </ng-container>

        <ng-container *ngIf="fields.length === 0">
        <tr>
          <td colspan="99">
            {{ loadingFields ? 'Loading...' : 'No custom fields' }}
          </td>
        </tr>
        </ng-container>

        <tr *ngIf="!loadingFields">
          <td colspan="99" class="table-button-cell">
            <button class="btn btn-outline-success btn-block"
                    [class.disabled]="loadingEdit"
                    [disabled]="loadingEdit"
                    (click)="openAddFieldModal()">
              Click to add
            </button>
          </td>
        </tr>

      </tbody>

    </table>
  </div>

</div>
